function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1.86719,
  y: 8.55078,
  width: 22.2769,
  height: 42.4483,
  rx: 2,
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8033 18.1866V19.1866H19.8033H24.696H25.696V18.1866V13.3713H30.5598H31.5598V12.3713V7.85236V6.85236H30.5598H25.696V2V1H24.696H19.8033H18.8033V2V6.85236H13.9395H12.9395V7.85236V12.3713V13.3713H13.9395H18.8033V18.1866Z",
  fill: "currentColor",
  stroke: "none",
  strokeWidth: 2
});

var SvgIcPlusColumn = function SvgIcPlusColumn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 52,
    viewBox: "0 0 33 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPlusColumn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_plus_column.dbceb315.svg";
export { ForwardRef as ReactComponent };